export const ICON_SET_FOLDER = "icons";

export const APP_ICON_MAPPING = [
  // MD3 activities icons
  { id: "type_biking", path: "directions_bike" },
  { id: "type_hiking", path: "hiking" },
  { id: "type_swimming", path: "pool" },
  { id: "type_watersports", path: "water" },
  { id: "type_unknown", path: "question_mark" },
  { id: "type_running", path: "directions_run" },
  { id: "type_walking", path: "directions_walk" },
  { id: "type_climbing", path: "mountain_flag" },
  { id: "type_skiing", path: "downhill_skiing" },
  { id: "type_surfing", path: "kitesurfing" },
  { id: "type_sailing", path: "sailing" },
  { id: "type_kayaking", path: "kayaking" },
  { id: "type_diving", path: "scuba_diving" },

  // MD3 GPX Data icons
  { id: "cadence", path: "cadence" },
  { id: "calories", path: "mode_heat" },
  { id: "distance", path: "arrow_range" },
  { id: "duration", path: "timelapse" },
  { id: "time", path: "timelapse" },
  { id: "gradient", path: "elevation" },
  { id: "elevation", path: "landscape" },
  { id: "heartrate", path: "favorite" },
  { id: "pace", path: "pace" },
  { id: "speed", path: "speed" },
  { id: "steps", path: "steps" },
  { id: "temperature", path: "device_thermostat" },
  { id: "stop", path: "coffee" },
];
export const resolveIcon = (symbol) => {
  let icon = "";
  if (!symbol) return icon;

  const appMapping = APP_ICON_MAPPING.find((item) => item.id === symbol);

  try {
    if (appMapping) {
      icon = require("@resources/svg/" + ICON_SET_FOLDER + "/" + appMapping.path + ".svg");
    } else {
      icon = require("@resources/svg/" + symbol + ".svg");
    }
  } catch (e) {
    // Catch error when file does not exist
    console.warn("Icon not found for symbol:", symbol);
    icon = "";
  }
  return icon;};
